import { html } from 'lit';

export const iconTrashCan = html`
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.69141 1.24219C3.82812 0.941406 4.12891 0.75 4.45703 0.75H7.76562C8.09375 0.75 8.39453 0.941406 8.53125 1.24219L8.75 1.625H11.375C11.8398 1.625 12.25 2.03516 12.25 2.5C12.25 2.99219 11.8398 3.375 11.375 3.375H0.875C0.382812 3.375 0 2.99219 0 2.5C0 2.03516 0.382812 1.625 0.875 1.625H3.5L3.69141 1.24219ZM0.847656 4.25H11.375V13C11.375 13.9844 10.582 14.75 9.625 14.75H2.59766C1.64062 14.75 0.847656 13.9844 0.847656 13V4.25ZM3.03516 6.4375V12.5625C3.03516 12.8086 3.25391 13 3.47266 13C3.71875 13 3.91016 12.8086 3.91016 12.5625V6.4375C3.91016 6.21875 3.71875 6 3.47266 6C3.25391 6 3.03516 6.21875 3.03516 6.4375ZM5.66016 6.4375V12.5625C5.66016 12.8086 5.87891 13 6.09766 13C6.34375 13 6.5625 12.8086 6.5625 12.5625V6.4375C6.5625 6.21875 6.34375 6 6.09766 6C5.87891 6 5.66016 6.21875 5.66016 6.4375ZM8.3125 6.4375V12.5625C8.3125 12.8086 8.50391 13 8.75 13C8.96875 13 9.1875 12.8086 9.1875 12.5625V6.4375C9.1875 6.21875 8.96875 6 8.75 6C8.50391 6 8.3125 6.21875 8.3125 6.4375Z"
      fill="currentColor"
    />
  </svg>
`;
